import React from 'react';

interface Props {
  className?: string;
}

const Loader = ({ className }: Props) => {
  return (
    <div id="global-loader" className={className}>
      <img src={require('./../../assets/img/loader.svg').default} className="loader-img" alt="Loader" />
    </div>
  );
};

export default Loader;
